import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SendIcon, CheckCircle2, MailIcon, MapPinIcon } from 'lucide-react';
const reasons = ['General enquiry', 'Business partnership', 'Press & media', 'Bug report', 'Feature request', 'Other'];
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-363">
      <Navbar data-id="element-364" />
      <main className="pt-36 pb-24" data-id="element-365">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-366">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center mb-14" data-id="element-367">
            <h1 className="text-4xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-368">
              Contact KittyPot
            </h1>
            <p className="text-lg text-gray-500 max-w-md mx-auto" data-id="element-369">
              Have a question, idea, or business enquiry? We'd love to hear from
              you.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-370">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="lg:col-span-3" data-id="element-371">
              {submitted ? <div className="bg-white rounded-2xl p-10 md:p-14 shadow-card border border-gray-100 text-center" data-id="element-372">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6" data-id="element-373">
                    <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-374" />
                  </div>
                  <h2 className="text-2xl font-bold text-kitty-dark mb-3" data-id="element-375">
                    Message sent!
                  </h2>
                  <p className="text-gray-500 max-w-sm mx-auto" data-id="element-376">
                    Thanks for reaching out. The KittyPot team will get back to
                    you as soon as possible.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-10 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-377">
                  <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-378" />

                  <div className="space-y-6 mt-2" data-id="element-379">
                    <div data-id="element-380">
                      <label htmlFor="name" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-381">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-382" />
                    </div>

                    <div data-id="element-383">
                      <label htmlFor="email" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-384">
                        Email
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-385" />
                    </div>

                    <div data-id="element-386">
                      <label htmlFor="reason" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-387">
                        Reason for contacting us
                      </label>
                      <select id="reason" name="reason" value={formData.reason} onChange={handleChange} required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 text-base transition-shadow appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%239ca3af%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat pr-10" data-id="element-388">
                        <option value="" disabled data-id="element-389">
                          Select a reason
                        </option>
                        {reasons.map(reason => <option key={reason} value={reason} data-id="element-390">
                            {reason}
                          </option>)}
                      </select>
                    </div>

                    <div data-id="element-391">
                      <label htmlFor="message" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-392">
                        Message
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Enter your message" required rows={5} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow resize-vertical" data-id="element-393" />
                    </div>

                    <button type="submit" className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-all active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-394">
                      Send Message
                      <SendIcon className="w-5 h-5" data-id="element-395" />
                    </button>
                  </div>
                </form>}
            </motion.div>

            {/* Contact Info Sidebar */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="lg:col-span-2 space-y-6" data-id="element-396">
              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-397">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-398">
                  <MailIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-399" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-400">Email us</h3>
                <a href="mailto:support@kittypot.com" className="text-gray-500 hover:text-kitty-dark transition-colors text-sm" data-id="element-401">
                  support@kittypot.com
                </a>
              </div>

              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-402">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-403">
                  <MapPinIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-404" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-405">Our address</h3>
                <address className="not-italic text-gray-500 text-sm leading-relaxed" data-id="element-406">
                  KittyPot Ltd
                  <br data-id="element-407" />
                  Flat 2 Minavon
                  <br data-id="element-408" />
                  Cardiff, CF14 6BE
                  <br data-id="element-409" />
                  United Kingdom
                </address>
              </div>

              <div className="bg-gray-950 rounded-2xl p-7 text-white" data-id="element-410">
                <p className="text-sm font-medium mb-1" data-id="element-411">Response time</p>
                <p className="text-gray-400 text-sm" data-id="element-412">
                  We typically reply within 24 hours on business days.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </main>
      <Footer data-id="element-413" />
    </div>;
}